import React from "react";
import LookupValuesEditor from "./shared/LookupValuesEditor";

const Roles = () => (
  <LookupValuesEditor kind="roles" singular="role" plural="roles" />
);

export default Roles;
